import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'bws-step',
    template: `
    <div [hidden]="!isActive">
      <ng-content></ng-content>
    </div>
  `,
    styles: [],
    standalone: false
})
export class StepComponent {

  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() hidden = false;
  @Input() isValid = true;
  @Input() showNext = true;
  @Input() showPrev = true;
  @Input() id = 0;

  @Output() onNext: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPrev: EventEmitter<any> = new EventEmitter<any>();
  @Output() onComplete: EventEmitter<any> = new EventEmitter<any>();

  private _isActive = false;
  isDisabled = true;

  constructor() { }

  @Input('isActive')
  set isActive(isActive: boolean) {
    this._isActive = isActive;
    this.isDisabled = false;
  }

  get isActive(): boolean {
    return this._isActive;
  }

}
